import { Button } from "@bleu.builders/ui";
import { Plus, Trash2 } from "lucide-react";
import React from "react";

import { useReceiptUpdate } from "./context";
import { PATCH_STATUSES } from "./receipt-items";

// const DownloadProcessedAnalysisJsonButton = ({ data, filename }) => {
//   const handleDownload = useCallback(() => {
//     const jsonData = JSON.stringify(data, null, 2);
//     const blob = new Blob([jsonData], { type: "application/json" });
//     const url = URL.createObjectURL(blob);

//     const link = document.createElement("a");
//     link.href = url;
//     link.download = filename || "download.json";
//     link.click();

//     URL.revokeObjectURL(url);
//   }, [data, filename]);

//   return (
//     <Button
//       size="sm"
//       variant="secondary"
//       className="hidden h-8 lg:flex"
//       onClick={handleDownload}
//     >
//       <ArrowDownIcon className="mr-2 size-4" />
//       Download Processed JSON
//     </Button>
//   );
// };

export function TableActions({ appendItem }) {
  const {
    setEditingItems,
    setNonSavedUpdates,
    selectedRows,
    fieldArray,
    form,
    setSelectedRows,
  } = useReceiptUpdate();

  const handleAdd = () => {
    const newItem = {
      id: "newid" + crypto.randomUUID(),
      sku: "",
      name: "",
      quantity: 1,
      unit_price: 0,
      price: 0,
      matched_product: "",
      matched_keyword: "",
      confidence: 0,
      eligible: false,
      points: 0,
      admin_comments: "",
      patch_status: PATCH_STATUSES.CREATED,
    };

    setEditingItems((prev) => [...prev, newItem.id]);
    setNonSavedUpdates((prev) => [...prev, newItem.id]);

    appendItem(newItem);
  };

  const handleBulkDelete = () => {
    const { fields } = fieldArray;

    const updatedFields = fields
      .filter(
        (field) =>
          !(
            selectedRows.includes(field.id) &&
            field.patch_status === PATCH_STATUSES.CREATED
          ),
      )
      .map((field) => {
        if (selectedRows.includes(field.id)) {
          return {
            ...field,
            patch_status: PATCH_STATUSES.DELETED,
          };
        }
        return field;
      });

    form.setValue("receipt_items", updatedFields);
    setSelectedRows([]);
  };

  return (
    <div className="flex items-center justify-evenly space-x-2 w-full">
      {/* <div className="flex space-x-2 justify-start  w-full">
        <DownloadProcessedAnalysisJsonButton
          data={processedAnalysisData}
          filename={`receipt-${receipt_id}-processed-analysis.json`}
        />
        <a
          href={rawDataUrl}
          className="flex items-center space-x-2 rounded-md p-2 h-8 px-3 text-xs w-fit bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80"
        >
          <ArrowDownIcon className="mr-2 size-4" />
          Download AWS Analysis Raw JSON
        </a>
      </div> */}
      <div className="flex space-x-2 justify-end  w-full">
        <Button onClick={handleBulkDelete} disabled={selectedRows.length === 0}>
          <Trash2 className="mr-2 size-4" />
          Delete Selected
        </Button>
        <Button onClick={handleAdd}>
          <Plus className="mr-2 size-4" />
          Add Item
        </Button>
      </div>
    </div>
  );
}
